import React from "react";
import { RoutesPaths } from "../Router/Constant";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <div className="headerShadowSection">
      <div className="container-fluid maxContainerSection">
        <div className="row headerSection">
          <div className="col-md-6 headerLogosec">
            <Link
              to={RoutesPaths.LANDING}
              className="textDecorationNone logoImageSection"
            >
              <img src="/assets/miaxaLogo.svg" alt="logo" />
            </Link>
          </div>
          <div className="col-md-6 headerRightSec">
            <div className="downloadAppButton">
              <Link
                to="https://apps.apple.com/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/assets/Apple-button.svg"
                  alt=""
                  className="img-fluid"
                />
              </Link>
              <Link
                to="https://play.google.com/store/apps/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/assets/Google-button.svg"
                  alt=""
                  className="img-fluid"
                />
              </Link>
            </div>
            {/* <button className="getStartedBtn">
              <img src="/assets/RocketLaunch.svg" alt="" />
              Get started
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
}
